import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  buildLoginRedirectPath,
  clearAuthSession,
  getStoredToken,
  isSessionTokenValid,
} from "../utils/authSession";

export default function ProtectedRoute() {
  const location = useLocation();
  const token = getStoredToken();

  if (!isSessionTokenValid(token)) {
    clearAuthSession();
    const nextPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginRedirectPath(nextPath)} replace />;
  }

  return <Outlet />;
}
